var map = {
	"./Avatar.svg": "8db2",
	"./CBG_verticale.webp": "7dae",
	"./WIP.webp": "84b8",
	"./aws_logo_white.webp": "46ae",
	"./background/Pianeta_1.svg": "7315",
	"./background/Pianeta_2.svg": "31fe",
	"./background/Pianeta_3.svg": "fe6b",
	"./background/PlatformBackground.webp": "30a1",
	"./background/PlatformBackground_old.webp": "c1cb",
	"./background/Spirale_spazio.svg": "9de7",
	"./background/Stella cadente.svg": "1544",
	"./background/Stella_cadente_stile_2.svg": "4988",
	"./background/Volpettina_1.svg": "afff",
	"./background/Volpettina_2.svg": "dbe0",
	"./camingocode-bold-webfont.woff": "8f31",
	"./camingocode-regular-webfont.woff": "1d91",
	"./course_bg.webp": "98db",
	"./demo/Sassolino Elenco.svg": "4c99",
	"./demo/background_space_wide.webp": "1df1",
	"./demo/file-download.svg": "16ff",
	"./demo/file-upload.svg": "5e47",
	"./demo/logo_wide.webp": "e074",
	"./demo/podium.webp": "25a1",
	"./event/hologram.webp": "4a05",
	"./font.otf": "380a",
	"./generali.webp": "e6e8",
	"./im2a.webp": "f854",
	"./landingPage/CentOS.webp": "934d",
	"./landingPage/DevSecOps.webp": "b331",
	"./landingPage/GitGitHub.webp": "11f5",
	"./landingPage/GoLang.webp": "777e",
	"./landingPage/HG_LOGO.webp": "4408",
	"./landingPage/HTML&CSS.webp": "03c1",
	"./landingPage/Javascript.webp": "d7a3",
	"./landingPage/Linux.webp": "1369",
	"./landingPage/LinuxUbuntu.webp": "25dd",
	"./landingPage/Logo_mod.webp": "a2e9",
	"./landingPage/NoCourseImg.webp": "85de",
	"./landingPage/PostgreSQL.webp": "526d",
	"./landingPage/Python_AI.webp": "bb0c",
	"./landingPage/React.webp": "ef43",
	"./landingPage/ReverseEngineering.webp": "4329",
	"./landingPage/Scrum.webp": "d48d",
	"./landingPage/background_image_mod.svg": "01de",
	"./landingPage/bell_icon.svg": "6179",
	"./landingPage/check.svg": "aa38",
	"./landingPage/download.svg": "3368",
	"./landingPage/frame_courses.webp": "eede",
	"./landingPage/frame_projects.webp": "54ff",
	"./landingPage/left-arrow.svg": "a9cd",
	"./landingPage/mobile-menu/x.svg": "e530",
	"./landingPage/send.svg": "bf2a",
	"./landingPage/social/facebook.svg": "ea23",
	"./landingPage/social/globe.svg": "bf69",
	"./landingPage/social/instagram.svg": "eb1f",
	"./landingPage/social/linkedin.svg": "1166",
	"./landingPage/social/twitter.svg": "2380",
	"./landingPage/social/youtube.svg": "0aab",
	"./landingPage/x.svg": "c9a1",
	"./m2a.webp": "ceb1",
	"./m2a_logo.webp": "8653",
	"./marconi_logo.webp": "1f42",
	"./menu/desktopMenu/DesktopMenuTile-active.svg": "e3e5",
	"./menu/desktopMenu/DesktopMenuTile-inactive.svg": "ac79",
	"./menu/desktopMenu/homePageButton.svg": "6dc0",
	"./ourOpportunities/AreaCV-min.jpg": "4db6",
	"./ourOpportunities/Campus-min.jpg": "da8a",
	"./ourOpportunities/PremioMarilli-min.jpg": "f58b",
	"./paleocapa_logo.webp": "c1ec",
	"./plus.svg": "8a37",
	"./space_background.webp": "737a",
	"./space_background_courses_area.webp": "981c",
	"./users-icon/schools.svg": "690d",
	"./users-icon/students.svg": "b5b6",
	"./users-icon/users.svg": "e16e",
	"./users-icon/volpe.svg": "5a74"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";